import { memo, useCallback } from 'react';

import GuardianEventRow from '@/features/guardian/components/guardian-event-row';
import type { FamilyAgendaItem } from './types';

type FamilyAgendaRowProps = {
  item: FamilyAgendaItem;
  isLast: boolean;
  onPress?: (item: FamilyAgendaItem) => void;
};

function FamilyAgendaRow({ item, isLast, onPress }: FamilyAgendaRowProps) {
  const handlePress = useCallback(() => {
    onPress?.(item);
  }, [item, onPress]);

  return (
    <GuardianEventRow
      accessibilityLabel={`${item.title} · ${item.playerName}`}
      accentColor={item.accentColor}
      playerAvatar={item.playerAvatar}
      playerName={item.playerName}
      showDivider={!isLast}
      title={item.title}
      variant="agenda"
      onPress={handlePress}
    />
  );
}

export default memo(FamilyAgendaRow);
